import { CSSObject } from '@emotion/react'
import { fontSizes, fontWeights } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

const remainingAssetsWrapper: CSSObject = {
  height: '250px',
  width: '435px',
}

const scrollWrapper: CSSObject = {
  marginTop: '47px',
  position: 'absolute',
}

const scroll: CSSObject = {
  display: 'flex',
  justifyContent: 'space-between',
  listStyleType: 'none',
  margin: 0,
  padding: 0,
  width: '435px',
  li: {
    alignItems: 'center',
    backgroundColor: 'white',
    color: colors.n7.base,
    cursor: 'pointer',
    display: 'flex',
    height: '181px',
    justifyContent: 'center',
    opacity: 100,
    transition: 'opacity 0.2s ease-in',
    width: '50px',
    zIndex: 10000,
    '&:hover': {
      color: colors.n3.base,
    },
  },
  'li.kuiper-remaining-asset-scroll-disabled': {
    opacity: 0,
    transition: 'opacity 0.2s ease-out',
    visibility: 'hidden',
    zIndex: 0,
  },
}

const header: CSSObject = {
  alignItems: 'center',
  color: colors.n3.base,
  display: 'flex',
  fontSize: fontSizes.caps.large,
  fontWeight: fontWeights.bold,
  justifyContent: 'space-between',
  padding: '17px 15px 14px 15px',
  textAlign: 'left',
  textTransform: 'uppercase',
  '.kuiper-icon-wrapper': {
    color: colors.n7.base,
    cursor: 'pointer',
    '&:hover': {
      color: colors.n3.base,
    },
  },
}

const imageWrapper: CSSObject = {
  display: 'flex',
  height: '197px',
  overflow: 'auto hidden',
  padding: '0 15px',
}

const itemWrapper: CSSObject = {
  padding: '0 12px 6px 0',
}

const draggableContainer: CSSObject = {
  cursor: 'grab',
  height: '180px',
  position: 'relative',
  width: '180px',
}

const assetBase: CSSObject = {
  height: '180px',
  width: '180px',
}

const getDragAreaStyling = (
  isDragging: boolean,
  isCurrentZone: boolean
): CSSObject => ({
  background: isCurrentZone ? 'rgba(255, 255, 255, 0.8)' : 'transparent',
  cursor: 'grab',
  height: '180px',
  position: 'absolute',
  width: '180px',
  zIndex: isDragging ? 1 : 0,
})

const styles = {
  assetBase,
  draggableContainer,
  getDragAreaStyling,
  header,
  imageWrapper,
  itemWrapper,
  remainingAssetsWrapper,
  scroll,
  scrollWrapper,
}

export { styles }
